import { NgModule } from '@angular/core';
import { AddressDetailsTabsComponent } from './address-details-tabs/address-details-tabs.component';
import { AhoyCustomerComponent } from './ahoy-customer.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { EditCustomerDetailsComponent } from './customer-details/edit-customer-details/edit-customer-details.component';
import { ErrorPopupComponent } from './error-popup/error-popup.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';

import {
  MatCommonModule,
  MatLineModule,
  MatNativeDateModule,
  MatOptionModule,
  MatPseudoCheckboxModule,
  MatRippleModule,
} from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@app/@shared/shared.module';
export const translateModule = TranslateModule.forChild();
@NgModule({
  declarations: [
    AhoyCustomerComponent,
    AddressDetailsTabsComponent,
    ErrorPopupComponent,
    CustomerDetailsComponent,
    EditCustomerDetailsComponent,
  ],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatCommonModule,
    translateModule,
    MatLineModule,
    MatNativeDateModule,
    MatOptionModule,
    MatPseudoCheckboxModule,
    MatRippleModule,
    MatSelectModule,
    CommonModule,
    SharedModule,
  ],
  exports: [
    AhoyCustomerComponent,
    AddressDetailsTabsComponent,
    CustomerDetailsComponent,
    EditCustomerDetailsComponent,
    ErrorPopupComponent,
  ],
})
export class AhoyCustomerModule {}
